import SpriteSymbol from "../../../../../../../ldplatform/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../ldplatform/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-download\"><path d=\"M512 576l256-256-192 0 0-256-128 0 0 256-192 0zM744.73472 471.26528l-71.74144 71.74144 260.07552 96.99328-421.0688 157.02016-421.0688-157.02016 260.07552-96.99328-71.74144-71.74144-279.26528 104.73472 0 256 512 192 512-192 0-256z\" p-id=\"6494\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol